<template>
  <div>
    <!-- Map Area Starts -->
    <section class="map-area section-padding cpinfo_section1 section">
      <div class="chanpin_info">
        <div class="banner-sun">
          <p class="p1 animate fadeInDown animated"
            style="animation-duration: 1s; animation-delay: 0.1s; visibility: visible;">
            {{ cpinfo.title }}
          </p>
          <P class="p3 animate fadeInUp animated"
            style="animation-duration: 1s; animation-delay: 0.3s; visibility: visible;">
          <p v-html="cpinfo.description"></p>
          <!-- {{cpinfo.description}} -->
          </P>
        </div>
        <div class="banner-sunb animate zoomInRight animated"
          style="animation-duration: 2s; animation-delay: 0.5s; visibility: visible;">
          <img :src="newurl + cpinfo.ico" style="width:70%" />
        </div>
        <div class="banner-sunc animate fadeInLeft animated">
          <div class="ccp1">
            <img :src="newurl + cpinfo.ico" style="width: 100%;" />
          </div>
        </div>
      </div>

    </section>
    <!-- Map Area End -->


    <section class="map-area section-padding cpinfo_section2 section">
      <div class="jscs_s01">
        <img src="/static/assets/images/cpinfoban.jpg" />
      </div>
      <div class="jscs_s02">
        <div style="width: 50%;margin-left: 10%;float: left;" class="ccvccdiv">
          <img src="/static/assets/images/biaoqian.jpg" /><br><br><br>
          <p style="font-size: 30px;" class="jishucanshuziti">技术参数</p>
        </div>
        <div class="ipahyyyzzz" style="width: 30%;margin-right: 10%;float: right;font-size: 14px;color: #4bbfbc; ">
          <div style="float: right; width: 250px;  height: 100px; margin-top: 50px;" class="bianhua003">
            <a :href="newurl + cpinfo.ext_zhegnshu" target="_blank">
              <div v-if="cpinfo.ext_zhegnshu" style="width: 40%;float: left; text-align: center;cursor: pointer;">
                <p><img src="/static/assets/images/wenjian.png" /></p>
                <p>产品手册下载</p>
              </div>
            </a>
            <a :href="newurl + cpinfo.ext_c3" target="_blank">
              <div v-if="cpinfo.ext_c3" style="width: 40%;float: right; text-align: center;cursor: pointer;">
                <p><img src="/static/assets/images/wenjian.png" /></p>
                <p>证书下载</p>
              </div>
            </a>
          </div>
          <!-- <p><img  src="/static/assets/images/wenjian.png"/></p>
                      <p><img  src="/static/assets/images/wenjian.png"/></p> -->
        </div>
      </div>
      <div class="jscs_s03">

        <div style="float: left;width: 50%;" class="zuozuozuo">
          <p v-html="cpinfo.ext_xingneng"></p>
        </div>
        <div style="float: right;width: 50%;" class="youyouyou">
          <p v-html="cpinfo.content"></p>
        </div>

      </div>


    </section>




  </div>
</template>
  
<script>
import axios from 'axios';
export default {
  data() {
    return {
      cpinfo: [],
      thisid: '',
      newurl: 'https://naduapi.jurenkeji.com.cn',
    };
  },
  mounted() {
    this.thisid = this.$route.query.id;

    //获取左侧分类
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/content/' + this.thisid, {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        //   console.log(response.data.data);
        //   response.data.data.description = response.data.data.description.split('●').join('<br>●').trim();

        // 判断是否包含“●”
        if (response.data.data.description.includes('●')) {
          response.data.data.description = response.data.data.content;
        }
        this.cpinfo = response.data.data;





      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });

  },
  methods: {
    reloadPage() {
      // console.log('3333')
      // 如果不是因为导航重复而出现错误，则重新加载页面
      window.location.reload()
    },
    // 截取新闻标题字符串至指定长度
    truncatecontent(dateStr, length = 20) {
      return dateStr.substring(0, length);
    },




  }
};
</script>
  
  


// WEBPACK FOOTER //
// Chanpin.vue?c2d9421e